var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.83337L8.47085 10.5962C9.02182 10.9819 9.29731 11.1748 9.59697 11.2495C9.86166 11.3154 10.1385 11.3154 10.4032 11.2495C10.7029 11.1748 10.9783 10.9819 11.5293 10.5962L18.3334 5.83337M5.66675 16.6667H14.3334C15.7335 16.6667 16.4336 16.6667 16.9684 16.3942C17.4388 16.1545 17.8212 15.7721 18.0609 15.3017C18.3334 14.7669 18.3334 14.0668 18.3334 12.6667V7.33337C18.3334 5.93324 18.3334 5.23318 18.0609 4.6984C17.8212 4.22799 17.4388 3.84554 16.9684 3.60586C16.4336 3.33337 15.7335 3.33337 14.3334 3.33337H5.66675C4.26662 3.33337 3.56655 3.33337 3.03177 3.60586C2.56137 3.84554 2.17892 4.22799 1.93923 4.6984C1.66675 5.23318 1.66675 5.93324 1.66675 7.33337V12.6667C1.66675 14.0668 1.66675 14.7669 1.93923 15.3017C2.17892 15.7721 2.56137 16.1545 3.03177 16.3942C3.56655 16.6667 4.26662 16.6667 5.66675 16.6667Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.655f4775931c829ebd7dcfb5b20735da.svg";
export { ForwardRef as ReactComponent };